import { HTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

type CardTone = "cream" | "navy" | "plain";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  tone?: CardTone;
}

const TONES: Record<CardTone, string> = {
  cream: "bg-cream-light border border-cream-border",
  navy: "bg-navy text-cream-light border border-navy",
  plain: "bg-transparent",
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ tone = "cream", className, ...rest }, ref) => (
    <div ref={ref} className={cn("rounded-2xl p-5", TONES[tone], className)} {...rest} />
  ),
);
Card.displayName = "Card";

export function CardHeader({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("mb-3 flex items-start justify-between gap-3", className)} {...rest} />;
}

export function SectionLabel({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn("section-label", className)} {...rest} />;
}
